import api from './api';

class SubUserService {

  // Create sub user
  static async createSubUser(subUserData) {
    try {
      const response = await api.post('/sub-users', subUserData);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error creating sub user:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to create sub user',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Get sub users
  static async getSubUsers(orgId) {
    try {
      const params = new URLSearchParams({       
        orgId: orgId || ''
      });
      
      const response = await api.get(`/sub-users?${params}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error fetching sub users:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch sub users',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Get sub user by ID
  static async getSubUserById(id) {
    try {
      const response = await api.get(`/sub-users/${id}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error fetching sub user:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch sub user',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Update sub user
  static async updateSubUser(id, subUserData) {
    try {
      const response = await api.put(`/sub-users/${id}`, subUserData);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error updating sub user:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to update sub user',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Delete sub user
  static async deleteSubUser(id) {
    try {
      const response = await api.delete(`/sub-users/${id}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error deleting sub user:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to delete sub user',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Activate sub user
  static async activateSubUser(id) {
    try {
      const response = await api.put(`/sub-users/${id}/activate`);
      return {
        success: true,
        message: response.data.message,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error activating sub user:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to activate sub user',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Deactivate sub user
  static async deactivateSubUser(id) {
    try {
      const response = await api.put(`/sub-users/${id}/deactivate`);
      return {
        success: true,
        message: response.data.message,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error deactivating sub user:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to deactivate sub user',
        error: error.response?.data?.error || error.message
      };
    }
  }

  // Toggle sub user status
  static async toggleSubUserStatus(id) {
    try {
      const response = await api.put(`/sub-users/${id}/toggle-status`);
      return {
        success: true,
        message: response.data.message,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error toggling sub user status:', error);
      throw {
        success: false,
        message: error.response?.data?.message || 'Failed to toggle sub user status',
        error: error.response?.data?.error || error.message
      };
    }
  }

}

export default SubUserService;